// extracted by mini-css-extract-plugin
export default {"privacy_box":"Privacy_privacy_box__uQgL8"};